// hooks/useCanOpenModal.ts
import { ISinisterValues } from "../../../shared/services/api/sinister/SinisterService";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { PermissionRolesEnum, PermissionActionsEnum } from "../../../shared/enums/profiles";
import { useProfile } from "../../../context/ProfileContext";

type ModalType = "openModalAproved" | "openModalRefused" | "openModalCancel" | "openModalContested" | "openModalValuesSinister" | "openModalDocumentValue";

export const useCanOpenModal = () => {
	const { isSuperAdmin, permissionLevel } = useProfile();

	const hasPermission = (role: PermissionRolesEnum, action: PermissionActionsEnum) => isSuperAdmin || checkByProfileGuard(role, action);

	const canOpenModal = (modal: ModalType, row: ISinisterValues): { canOpen: boolean; reason?: string } => {
		switch (modal) {
			case "openModalAproved":
				if (!(row.status === "open" || row.status === "contested")) {
					return { canOpen: false, reason: "Apenas valores em aberto ou contestados podem ser aprovados." };
				}
				if (!hasPermission(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Approve)) {
					return { canOpen: false, reason: "Você não tem permissão para aprovar valores." };
				}
				return { canOpen: true };

			case "openModalRefused":
				if (row.status !== "open") return { canOpen: false, reason: "Apenas valores pendentes podem ser recusados." };
				if (!hasPermission(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Reject))
					return { canOpen: false, reason: "Você não tem permissão para recusar valores." };
				return { canOpen: true };

			case "openModalCancel":
				if (row.status !== "open") return { canOpen: false, reason: "Apenas valores aprovados podem ser cancelados." };
				if (!hasPermission(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Cancel))
					return { canOpen: false, reason: "Você não tem permissão para cancelar valores." };
				return { canOpen: true };

			case "openModalContested":
				if (row.status !== "approved") return { canOpen: false, reason: "Apenas valores aprovados podem ser contestados." };
				if (!hasPermission(PermissionRolesEnum.SinisterValuesOptions, PermissionActionsEnum.Contest))
					return { canOpen: false, reason: "Você não tem permissão para contestar valores." };
				return { canOpen: true };

			default:
				return { canOpen: false, reason: "Modal não reconhecido." };
		}
	};

	return { canOpenModal };
};
